import { MultiSectionLayout } from "@jugl-web/ui-components/cross-platform";
import { HeaderBreadcrumbs, TabsLayout } from "@jugl-web/ui-components/web";
import { useTranslations } from "@jugl-web/utils";
import { useNavigation } from "@web-src/modules/navigation/hooks/useNavigation";

type InvoicesSettingsPageLayoutProps = {
  tab: string;
  children: React.ReactNode;
};

export const InvoicesSettingsPageLayout = ({
  tab,
  children,
}: InvoicesSettingsPageLayoutProps) => {
  const { t } = useTranslations();
  const { navigateToPage } = useNavigation();

  const headerItems = [
    {
      title: t({
        id: "invoices-item-form-page.invoices",
        defaultMessage: "Invoices",
      }),
      onClick: () => navigateToPage("invoices"),
    },
    {
      title: t({
        id: "invoices-settings-page.settings",
        defaultMessage: "Settings",
      }),
    },
  ];

  return (
    <>
      <MultiSectionLayout
        header={
          <>
            <HeaderBreadcrumbs items={headerItems} disableShadow />
          </>
        }
      >
        <TabsLayout
          selectedTab={tab}
          tabs={[
            {
              id: "business-information",
              title: t({
                id: "invoices-settings-page.business-information",
                defaultMessage: "Business information",
              }),
              onClick: () =>
                navigateToPage("invoicesSettingsBusinessInformation"),
            },
            // {
            //   id: "client-defaults",
            //   title: t({
            //     id: "invoices-settings-page.client-defaults",
            //     defaultMessage: "Client defaults",
            //   }),
            //   onClick: () => navigateToPage("invoicesSettingsClientDefaults"),
            // },
          ]}
        >
          <main className="h-full bg-[#DFE2E3]">{children}</main>
        </TabsLayout>
      </MultiSectionLayout>
    </>
  );
};
